import { useMutation } from "@tanstack/react-query";
import { useAxios } from "../../utils/hooks/useAxios";

/**
 * POST profile/confirm-email-verification-code — body: { otp: string }
 * POST profile/resend-email-verification — no body, Bearer token
 * (Paths are under REACT_APP_API_URL, typically .../api/v1/)
 */
export const useVerifyEmailMutation = () => {
  const { axiosProtected } = useAxios();

  return useMutation({
    mutationFn: (payload) =>
      axiosProtected.post("profile/confirm-email-verification-code", payload),
    mutationKey: "confirm-email-verification-code",
  });
};

export const useResendEmailVerificationMutation = () => {
  const { axiosProtected } = useAxios();

  return useMutation({
    mutationFn: () =>
      axiosProtected.post("profile/resend-email-verification"),
    mutationKey: "resend-email-verification",
  });
};
